var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHeart = function SvgHeart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 20c.35 0 1.403 0 9.628-8.434a6.897 6.897 0 0 0 1.797-4.877A6.93 6.93 0 0 0 21.628 1.8a6.136 6.136 0 0 0-8.682 0L12 2.749l-.946-.948a6.137 6.137 0 0 0-8.683 0A6.93 6.93 0 0 0 .575 6.689a6.897 6.897 0 0 0 1.796 4.877C10.597 20 11.65 20 12 20Z",
    fill: "#fff"
  })));
};
export default SvgHeart;